import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/Store',
    name: 'Store',
    component: () => import('../views/Boweishangcheng/Shangchengshouye.vue')
  },
  {
    path: '/Shangpinxiangqing',
    name: 'Shangpinxiangqing',
    component: () => import('../views/Boweishangcheng/Shangpinxiangqing.vue')
  },
  {
    path: '/Shangpinfenlei',
    name: 'Shangpinfenlei',
    component: () => import('../views/Boweishangcheng/Shangpinfenlei.vue')
  },
  {
    path: '/Gouwuche',
    name: 'Gouwuche',
    component: () => import('../views/Boweishangcheng/Gouwuche.vue')
  },
  {
    path: '/Querenxiadan',
    name: 'Querenxiadan',
    component: () => import('../views/Boweishangcheng/Querenxiadan.vue')
  },
  {
    path: '/Dingdanzhifu',
    name: 'Dingdanzhifu',
    component: () => import('../views/Boweishangcheng/Dingdanzhifu.vue')
  },
  {
    path: '/Scheme',
    name: 'Scheme',
    component: () => import('../views/Jiejuefangan/Jiejuefangan.vue')
  },
  {
    path: '/Anlixiangqing',
    name: 'Anlixiangqing',
    component: () => import('../views/Jiejuefangan/Anlixiangqing.vue')
  },
  {
    path: '/Community',
    name: 'Community',
    component: () => import('../views/Boweishequ/Shequshouye.vue')
  },
  {
    path: '/Shequfenlei',
    name: 'Shequfenlei',
    component: () => import('../views/Boweishequ/Shequfenlei.vue')
  },
  {
    path: '/Tiezixiangqing',
    name: 'Tiezixiangqing',
    component: () => import('../views/Boweishequ/Tiezixiangqing.vue')
  },
  {
    path: '/Gerenzhuye',
    name: 'Gerenzhuye',
    component: () => import('../views/Boweishequ/Gerenzhuye.vue')
  },
  {
    path: '/MachineTool',
    name: 'MachineTool',
    component: () => import('../views/Jichuanzhuanqu/Zhuanqushouye.vue')
  },
  {
    path: '/Jichuangliebiao',
    name: 'Jichuangliebiao',
    component: () => import('../views/Jichuanzhuanqu/Jichuangliebiao.vue')
  },
  {
    path: '/Jichuangxiangqing',
    name: 'Jichuangxiangqing',
    component: () => import('../views/Jichuanzhuanqu/Jichuangxiangqing.vue')
  },
  {
    path: '/JcQuerenxiadan',
    name: 'JcQuerenxiadan',
    component: () => import('../views/Jichuanzhuanqu/Querenxiadan.vue')
  },
  {
    path: '/Yixiangjinzhifu',
    name: 'Yixiangjinzhifu',
    component: () => import('../views/Jichuanzhuanqu/Yixiangjinzhifu.vue')
  },
  {
    path: '/Fuwuxiangqing',
    name: 'Fuwuxiangqing',
    component: () => import('../views/Jichuanzhuanqu/Fuwuxiangqing.vue')
  },
  {
    path: '/Training',
    name: 'Training',
    component: () => import('../views/Peixunzhongxin/Peixunzhongxin.vue')
  },
  {
    path: '/Peixunliebiao',
    name: 'Peixunliebiao',
    component: () => import('../views/Peixunzhongxin/Peixunliebiao.vue')
  },
  {
    path: '/Peixunxiangqing',
    name: 'Peixunxiangqing',
    component: () => import('../views/Peixunzhongxin/Peixunxiangqing.vue')
  },
  {
    path: '/Peixunxiadan',
    name: 'Peixunxiadan',
    component: () => import('../views/Peixunzhongxin/Peixunxiadan.vue')
  },
  {
    path: '/News',
    name: 'News',
    component: () => import('../views/Hangyezixun/Hangyezixun.vue')
  },
  {
    path: '/Zixunxiangqing',
    name: 'Zixunxiangqing',
    component: () => import('../views/Hangyezixun/Zixunxiangqing.vue')
  },
  {
    path: '/Living',
    name: 'Living',
    component: () => import('../views/Zhibozhongxin/Zhibozhongxin.vue')
  },
  {
    path: '/MyOrder',
    name: 'MyOrder',
    component: () => import('../views/My/MyOrder.vue')
  },
  {
    path: '/Lingshoudingdanxiangqing',
    name: 'Lingshoudingdanxiangqing',
    component: () => import('../views/My/Lingshoudingdanxiangqing.vue')
  },
  {
    path: '/Jiagongdingdanxiangqing',
    name: 'Jiagongdingdanxiangqing',
    component: () => import('../views/My/Jiagongdingdanxiangqing.vue')
  },
  {
    path: '/MyOrderJcFw',
    name: 'MyOrderJcFw',
    component: () => import('../views/My/MyOrderJcFw.vue')
  },
  {
    path: '/MyOrderJsFw',
    name: 'MyOrderJsFw',
    component: () => import('../views/My/MyOrderJsFw.vue')
  },
  {
    path: '/Jichuangdingdanxiangqing',
    name: 'Jichuangdingdanxiangqing',
    component: () => import('../views/My/Jichuangdingdanxiangqing.vue')
  },
  {
    path: '/Fuwudingdanxiangqing',
    name: 'Fuwudingdanxiangqing',
    component: () => import('../views/My/Fuwudingdanxiangqing.vue')
  },
  {
    path: '/PointsMall',
    name: 'PointsMall',
    component: () => import('../views/Jifenshangcheng/Jifenshangcheng.vue')
  },
  {
    path: '/Jifenshangchengxiangqing',
    name: 'Jifenshangchengxiangqing',
    component: () => import('../views/Jifenshangcheng/Jifenshangchengxiangqing.vue')
  },
  {
    path: '/Jifenshangchengxiadan',
    name: 'Jifenshangchengxiadan',
    component: () => import('../views/Jifenshangcheng/Jifenshangchengxiadan.vue')
  },
  {
    path: '/Dizhiguanli',
    name: 'Dizhiguanli',
    component: () => import('../views/My/Dizhiguanli.vue')
  },
  {
    path: '/Kaipiaojilu',
    name: 'Kaipiaojilu',
    component: () => import('../views/My/Kaipiaojilu.vue')
  },
  {
    path: '/Wodepinglun',
    name: 'Wodepinglun',
    component: () => import('../views/My/Wodepinglun.vue')
  },
  {
    path: '/HelpCenter',
    name: 'HelpCenter',
    component: () => import('../views/My/HelpCenter.vue')
  },
  {
    path: '/HelpDetail',
    name: 'HelpDetail',
    component: () => import('../views/My/HelpDetail.vue')
  },
  {
    path: '/Yinsizhengce',
    name: 'Yinsizhengce',
    component: () => import('../views/My/Yinsizhengce.vue')
  },
  {
    path: '/Huiyuanzhongxing',  // 会员中心-基本信息
    name: 'Huiyuanzhongxing',
    component: () => import('../views/My/Huiyuanzhongxing.vue')
  },
  {
    path: '/Hyzx_qiyerenzheng_dai', // 会员中心-企业认证
    name: 'Hyzx_qiyerenzheng_dai',
    component: () => import('../views/My/Hyzx_qiyerenzheng_dai.vue')
  },
  {
    path: '/Hyzx_kaipiaoziliao', // 会员中心-开票资料
    name: 'Hyzx_kaipiaoziliao',
    component: () => import('../views/My/Hyzx_kaipiaoziliao.vue')
  },
  {
    path: '/Hyzx_yuangongguanli', // 会员中心-员工管理
    name: 'Hyzx_yuangongguanli',
    component: () => import('../views/My/Hyzx_yuangongguanli.vue')
  },
  {
    path: '/Hyzx_zhanghaoanquan', // 会员中心-账户安全
    name: 'Hyzx_zhanghaoanquan',
    component: () => import('../views/My/Hyzx_zhanghaoanquan.vue')
  },
  {
    path: '/Hyzx_wodexunjia', // 会员中心-我的询价
    name: 'Hyzx_wodexunjia',
    component: () => import('../views/My/Hyzx_wodexunjia.vue')
  },
  {
    path: '/Hyzx_wodeshouhou', // 会员中心-我的售后
    name: 'Hyzx_wodeshouhou',
    component: () => import('../views/My/Hyzx_wodeshouhou.vue')
  },
  {
    path: '/Shxq_tuikuan', // 售后详情-退款
    name: 'Shxq_tuikuan',
    component: () => import('../views/My/Shxq_tuikuan.vue')
  },
  {
    path: '/Hhfw_wodishiyang', // 客户服务-我的试样
    name: 'Hhfw_wodishiyang',
    component: () => import('../views/My/Hhfw_wodishiyang.vue')
  },
  {
    path: '/Hhfw_hezuoshangpin', // 客户服务-合作商品
    name: 'Hhfw_hezuoshangpin',
    component: () => import('../views/My/Hhfw_hezuoshangpin.vue')
  },
  {
    path: '/Hhfw_liangshendingzhi', // 客户服务-量身定制
    name: 'Hhfw_liangshendingzhi',
    component: () => import('../views/My/Hhfw_liangshendingzhi.vue')
  },
  {
    path: '/Wdzc_wodejifeng', // 我的资产-我的积分
    name: 'Wdzc_wodejifeng',
    component: () => import('../views/My/Wdzc_wodejifeng.vue')
  },
  {
    path: '/Jfxq_detail', // 积分兑换详情订单-代发货
    name: 'Jfxq_detail',
    component: () => import('../views/My/Jfxq_detail.vue')
  },
  {
    path: '/Hffw_wodepeixun', // 客户服务-我的培训
    name: 'Hffw_wodepeixun',
    component: () => import('../views/My/Hffw_wodepeixun.vue')
  },
  {
    path: '/Hffw_detail', // 客户服务-我的培训详情
    name: 'Hffw_detail',
    component: () => import('../views/My/Hffw_detail.vue')
  },
  {
    path: '/Wdzc_wodeqiandao', // 我的资产-我的签到
    name: 'Wdzc_wodeqiandao',
    component: () => import('../views/My/Wdzc_wodeqiandao.vue')
  },
  {
    path: '/Wdzc_wodeyouhuiquan', // 我的资产-我的优惠券
    name: 'Wdzc_wodeyouhuiquan',
    component: () => import('../views/My/Wdzc_wodeyouhuiquan.vue')
  },
  {
    path: '/Wdzc_wodeedu', // 我的资产-我的额度
    name: 'Wdzc_wodeedu',
    component: () => import('../views/My/Wdzc_wodeedu.vue')
  },
  {
    path: '/Wdzc_wodefeisi', // 我的资产-我的废丝
    name: 'Wdzc_wodefeisi',
    component: () => import('../views/My/Wdzc_wodefeisi.vue')
  },
  {
    path: '/Wdzc_woshoucang', // 我的资产-我的收藏
    name: 'Wdzc_woshoucang',
    component: () => import('../views/My/Wdzc_woshoucang.vue')
  },
  {
    path: '/Wdsq_wodeguanzhu', // 我的社区-我的关注
    name: 'Wdsq_wodeguanzhu',
    component: () => import('../views/My/Wdsq_wodeguanzhu.vue')
  },
  {
    path: '/Wdsq_wodetiezi', // 我的社区-我的帖子
    name: 'Wdsq_wodetiezi',
    component: () => import('../views/My/Wdsq_wodetiezi.vue')
  },
  {
    path: '/Xtsz_wodexiaoxi', // 系统设置-我的消息
    name: 'Xtsz_wodexiaoxi',
    component: () => import('../views/My/Xtsz_wodexiaoxi.vue')
  },
  {
    path: '/AboutUs', // 关于我们
    name: 'AboutUs',
    component: () => import('../views/My/AboutUs.vue')
  },
  {
    path: '/Taocan', // 套餐列表
    name: 'Taocan',
    component: () => import('../views/Taocan/Taocanliebiao.vue')
  },
  {
    path: '/Taocanxiangqing', // 套餐详情
    name: 'Taocanxiangqing',
    component: () => import('../views/Taocan/Taocanxiangqing.vue')
  },
  {
    path: '/Taocanquerenxiadan', // 确认下单
    name: 'Taocanquerenxiadan',
    component: () => import('../views/Taocan/Querenxiadan.vue')
  },
  {
    path: '/ActivityOne', // 秒杀-满折满减
    name: 'ActivityOne',
    component: () => import('../views/Activity/ActivityOne.vue')
  },
  {
    path: '/ActivityTwo', // 表单
    name: 'ActivityTwo',
    component: () => import('../views/Activity/ActivityTwo.vue')
  },
  {
    path: '/ActivityThree', // 秒杀-集合
    name: 'ActivityThree',
    component: () => import('../views/Activity/ActivityThree.vue')
  },
  {
    path: '/Ranklist', // 好物榜
    name: 'Ranklist',
    component: () => import('../views/Activity/Ranklist.vue')
  },
  {
    path: '/AboutUsTwo', // 关于我们-个人中心
    name: 'AboutUsTwo',
    component: () => import('../views/My/AboutUsTwo.vue')
  },
  {
    path: '/Fuwuxieyi', // 服务协议
    name: 'Fuwuxieyi',
    component: () => import('../views/My/Fuwuxieyi.vue')
  },
  {
    path: '/Hezuoshangpin', // 合作商品-个人中心
    name: 'Hezuoshangpin',
    component: () => import('../views/Boweishangcheng/Hezuoshangpin.vue')
  },
    {
    path: '/supplyList',//供需列表
    name: 'supplyList',
    component: () => import('../views/supply/supplyList.vue')
  },
      {
    path: '/supplyDetail',//供需详情
    name: 'supplyDetail',
    component: () => import('../views/supply/supplyDetail.vue')
  },
        {
    path: '/addSupply',//发布供需供需
    name: 'addSupply',
    component: () => import('../views/supply/addSupply.vue')
  },
     {
    path: '/mySupplyList',//我发布的供需
    name: 'mySupplyList',
    component: () => import('../views/supply/mySupplyList.vue')
  },
    {
    path: '/myExchangeSupply',//供需-兑换记录
    name: 'myExchangeSupply',
    component: () => import('../views/supply/myExchangeSupply.vue')
  },



  
  {
    path: '/Login',//登录
    name: 'Login',
    component: () => import('../views/Login/Login.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
